module.exports = __webpack_public_path__ + "static/media/LabTable.f2958d98.svg";